export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const emailIcon = require("../assets/image_Message1.png");
export const PasswordVisible = require("../assets/password_visible.png");
export const asswordInVisible = require("../assets/password_invisible.png");
export const logo = require("../assets/logo.png")